@if (visible) {
    <form #stepForm="ngForm" class="form-page">
        <div class="title-start">
            <strong>{{ 'steps.tenant-invite-success.start' | translate: { tenantName: acceptedTenantName } }}</strong>
            <p [innerHTML]="'steps.tenant-invite-success.start_subtitle' | translate"></p>
        </div>
    </form>
}
